import axios from "axios";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { base_url, BASE_URL } from "../../config";
import { encryptData, decryptData } from "../../helper";



export default function CookieConsentApp() {
  const [showPopup, setShowPopup] = useState(false);
  const [isHiding, setIsHiding] = useState(false);
  const [cookieConsent, setCookieConsent] = useState(null);
  const [apiData, setApiData] = useState({})
  const { user } = useSelector((state) => state.user);
  const [cookieData, setCookieData] = useState({})
  const [browserN, setBrowserN] = useState('')


  const fatch = () => {
    if (localStorage.getItem('uuid')) {
      
    const userAgent = navigator.userAgent;

    let browserName = "Unknown";
    if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
      browserName = "Chrome";
    } else if (userAgent.includes("Firefox")) {
      browserName = "Firefox";
    } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      browserName = "Safari";
    } else if (userAgent.includes("Edg")) {
      browserName = "Edge";
    } else if (userAgent.includes("OPR") || userAgent.includes("Opera")) {
      browserName = "Opera";
    }

    setBrowserN(browserName)

    const payload = {
      device_unique: localStorage.getItem('uuid'),
      new_device_unique: localStorage.getItem('new_uuid'),
      browser_type: browserName
    }
    setShowPopup(false)
    axios.post(`${BASE_URL}/check-cookie-policy-status`, payload).then((res) => {
      if ((res?.data?.data?.is_cookie_show == "1" || !localStorage.getItem('cookie')) ) {
            document.body.classList.add('b_bg', 'overflow-hidden');
        setCookieData(res?.data?.data)
        if (!localStorage.getItem('cookie') || res?.data?.data?.is_cookie_show == "1") {
          setShowPopup(true)
        } else {
          setShowPopup(false)
        }
      } else {
        setShowPopup(false)
      }
    }).catch((err) => {
      console.log(err)
    })
    }
  }



  useEffect(() => {
    fatch()
  }, []);

  const acceptCookies = () => {
    setShowPopup(false)
      setIsHiding(false);
     document.body.classList.remove('b_bg', 'overflow-hidden');

    // axios.get('https://ipwho.is/').then((res) => {
      const payload = {
        // ip: res?.data?.ip,
        // country: res?.data?.country,
        // timestamp: res?.data?.timezone?.current_time,
        user_id: user?.id ? user?.id : 0,
        device_unique: localStorage.getItem('uuid'),
        decision: '1',
        version: cookieData?.cookie_text?.id,
        browser_type: browserN
      }
      axios.post(`${BASE_URL}/update-cookie-policy-status`, payload).then((res) => {
        if (res?.status) {
          setShowPopup(false)
      setIsHiding(false);
          // fatch()
        }
      }).catch((err) => {
        console.log(err, "===")
      })
    // }).catch((err) => {
    //   console.log(err)
    // })
    localStorage.setItem('cookie', 'accepted')
    setCookieConsent("accepted");
    // hideCookiePopup();
  };

  const rejectCookies = () => {
    setShowPopup(false)
      setIsHiding(false);
     document.body.classList.remove('b_bg', 'overflow-hidden');

    // axios.get('https://ipwho.is/').then((res) => {
      const payload = {
        // ip: res?.data?.ip,
        // country: res?.data?.country,
        // timestamp: res?.data?.timezone?.current_time,
        user_id: user?.id ? user?.id : 0,
        device_unique: localStorage.getItem('uuid'),
        decision: '0',
        version: cookieData?.cookie_text?.id,
        browser_type: browserN
      }
      axios.post(`${BASE_URL}/update-cookie-policy-status`, payload).then((res) => {
        if (res?.status) {
          setShowPopup(false)
      setIsHiding(false);
          // fatch()
        }
      }).catch((err) => {
        console.log(err, "===")
      })
    // }).catch((err) => {
    //   console.log(err)
    // })
    localStorage.setItem('cookie', 'rejected')
    setCookieConsent("rejected");
    // hideCookiePopup();
  };

  const hideCookiePopup = () => {
    setIsHiding(true);
    setTimeout(() => {
      setShowPopup(false);
      setIsHiding(false);
    }, 400);
  };


  return (
    <>
      {showPopup && (
        <div
          className={`cookies-modal position-fixed w-100 d-flex justify-content-center ${isHiding ? "fade" : "fade show"
            }`}
          style={{
            bottom: "20px",
            left: 0,
            zIndex: 1050,
          }}
        >
          <div
            className="bg-white shadow-lg p-4 cookie-consent-popup"
            
          >
            <p className="mb-3 mb-md-0 text-dark small mr-md-3 cookies-modal-txt" style={{ fontSize: "15px" }}>
              <div dangerouslySetInnerHTML={{ __html: cookieData?.cookie_text?.content }}></div>
            </p>
            <div className="text-right mt-4 row justify-content-end">
              <div className="col-6 col-sm-4 col-md-3">
                <button
                  onClick={rejectCookies}
                  className="mr-2 btn btnRound_Line w-100 cookie-btn"
                >
                  <FormattedMessage id="CookieSettings" defaultMessage="CookieSettings" />
                </button>
              </div>
              <div className="col-6 col-sm-4 col-md-3">
                <button onClick={acceptCookies} className="btn btn-primary btnFUll_Bg w-100 cookie-btn">
                  <FormattedMessage id="Accept" defaultMessage='Accept' />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
